import React, { useState } from 'react';
import Slider from 'react-slick';
import { useSelector } from 'react-redux';
import Modal from 'react-modal';
import ReactPlayer from 'react-player';
import { Link, useNavigate } from 'react-router-dom';
import videoIcon from '../../../Assets/Icons/video-icon.svg';
import locationPhoneIcon from 'Assets/Icons/location-call.svg';
import mailIcon from 'Assets/Icons/mail-icon.png';
import WhiteColorLocation from 'Assets/SVG/OrangeLocationIcon.svg';
import DirectionColorIcon from 'Assets/images/direction-icon.png';
import RatingModal from 'Pages/Booking/Components/RatingModal';

const LablistCityWise = ({ data, heading, cityName }) => {
  const [showModal, setShowModal] = useState('');
  const [activeModal, setActiveModal] = useState(false);
  const [openRatingModal, setOpenRatingModal] = useState(false);
  const { token } = useSelector((state) => state.login);
  const navigate = useNavigate();
  const { lat, lng } = useSelector((state) => state.location);

  const settings = {
    arrows: false,
    dots: true, // Ensure dots are enabled
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1, // Always scroll one slide to avoid mismatch
    lazyLoad: true, // Disable lazy loading to prevent delayed rendering
    infinite: false, // Enable infinite scrolling for a seamless experience
    autoplay: true, // Enable autoplay for the slider
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1, // Ensure only one slide scrolls on small screens
          dots: true
        }
      }
    ]
  };

  const handleOpenModal = (val) => {
    setActiveModal(val);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowModal('');
  };

  const handleShareExperience = () => {
    if (token) {
      setOpenRatingModal(true);
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="section-heading">
            <h2>{heading}</h2>
            {data?.length >= 4 && (
              <Link
                className={'viewall-btn'}
                to={`/locatelab/${cityName}`}
              >
                View All
              </Link>
            )}
          </div>
        </div>
        <div className="col-12">
          {data?.length > 0 && (
            <Slider
              {...settings}
              className="happy-customer-content"
            >
              {data?.map((item, index) => (
                <div
                  key={item.testimonial_id}
                  className=""
                >
                  <div className="search-result-item lab-list-content">
                    <div
                      key={index}
                      className="search-result-item-content"
                    >
                      <h3>{item?.branch_name}</h3>
                      {/* <div style={{marginTop: 10}}>
                                                  <span style={{padding:"5px", display:"inline-block"}}>{item?.address}</span>
                                              </div> */}
                      <div className="location-address">
                        <figure className="location-address-icon">
                          <img
                            src={WhiteColorLocation}
                            alt=""
                          />
                        </figure>
                        <p>{item?.address}</p>
                        {item?.latitude && item?.longitude && (
                          <figure className="location-address-icon">
                            <a
                              href={`https://www.google.com/maps/dir/?api=1&origin=${lat},${lng}&destination=${item?.latitude},${item?.longitude}&travelmode=driving`}
                              target="_blank"
                            >
                              <img
                                src={DirectionColorIcon}
                                alt=""
                              />
                            </a>
                          </figure>
                        )}
                      </div>

                      {item?.email && (
                        <div className="location-address">
                          <figure className="location-address-icon">
                            <img
                              src={mailIcon}
                              alt=""
                            />
                          </figure>
                          <p>{item?.email ? item?.email : '-'}</p>
                        </div>
                      )}
                      {item?.contactno && (
                        <div className="location-address">
                          <figure className="location-address-icon">
                            <img
                              src={locationPhoneIcon}
                              alt=""
                            />
                          </figure>
                          <p>{item?.contactno ? item?.contactno : '-'}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          )}
        </div>
      </div>
    </div>
  );
};

export default LablistCityWise;
